import axios from 'axios';
import qs from 'qs'
import baseURL from './env.js';

axios.defaults.timeout = 5000;
axios.defaults.baseURL = baseURL;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//http request 拦截器
	axios.interceptors.request.use(function(config) {
		if (config.method === 'get') {
			config.paramsSerializer = function(params) {
				return qs.stringify(params, {
					arrayFormat: 'repeat'
				})
			}
			// config['responseType'] = 'arraybuffer''
		}
		var v = window.document.cookie.match('(^|;) ?' + 'token' + '=([^;]*)(;|$)');
		if (v) {
			config.headers['Authorization'] = 'bearer '+v[2]
		}else{
			config.headers['Authorization'] = 'Basic aG90ZWw6aG90ZWwxMjM='
		}
		config.headers['responseType'] = "blob"
		return config;
	}, function(error) {
		return Promise.reject(error);
	});
  
  
  //http response 拦截器
	axios.interceptors.response.use(function(response) {
		return response;
	}, function(error) {
		return Promise.reject(error);
	});
  
  
  /**
   * 封装get方法
   * @param url
   * @param data
   * @returns {Promise}
   */
  
	export function fetch(url,params={}){
		return new Promise((resolve,reject) => {
			axios.get(url,{
				params:params
			}).then(response => {
				resolve(response.data);
			}).catch(err => {
				reject(err)
			})
		})
	}
  
  /**
   * 封装post请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  
	export function post(url,data = {}){
		return new Promise((resolve,reject) => {
			axios.post(url,data).then(response => {
				resolve(response.data);
			},err => {
				reject(err)
			})
		})
	}
//  return new Promise ((resolve, reject) => {
// 	axios.post(url, params).then(res => {
// 		if(res.status==200){
// 			resolve(res)
// 		}
// 	}).catch(error => {
// 		reject(error)
// 	})
// })

//  /**
//  * 封装patch请求
//  * @param url
//  * @param data
//  * @returns {Promise}
//  */

// export function patch(url,data = {}){
//   return new Promise((resolve,reject) => {
//     axios.patch(url,data)
//          .then(response => {
//            resolve(response.data);
//          },err => {
//            reject(err)
//          })
//   })
// }

//  /**
//  * 封装put请求
//  * @param url
//  * @param data
//  * @returns {Promise}
//  */

// export function put(url,data = {}){
//   return new Promise((resolve,reject) => {
//     axios.put(url,data)
//          .then(response => {
//            resolve(response.data);
//          },err => {
//            reject(err)
//          })
//   })
// }


// WEBPACK FOOTER //
// ./src/utils/http.js